import {
  AttendanceEnumsPoolTypeEnum,
  AttendanceTimeBlock,
  Maybe,
} from 'generated/resources/graphql'
import { AttendanceSidepanelCompensationBlockFragment } from 'generated/resources/graphql'

const ONE_HOUR_IN_CENTS = 6000

export class UniqueTimeBlockData {
  equivalentMinutes: number
  minutes: number
  name: string
  rawMinutes: number
  sourcePoolType: AttendanceEnumsPoolTypeEnum
  timeSettingsCustomTimeRangeCategoryId: Maybe<number> | undefined

  static fromAttendanceBlock(timeBlocks: AttendanceTimeBlock) {
    return new UniqueTimeBlockData(
      (timeBlocks.equivalentMinutesInCents || ONE_HOUR_IN_CENTS) / 100,
      Number(timeBlocks.minutes),
      timeBlocks.name || '',
      (timeBlocks.rawMinutesInCents || ONE_HOUR_IN_CENTS) / 100,
      timeBlocks.sourcePoolType,
      timeBlocks.timeSettingsCustomTimeRangeCategoryId
    )
  }

  static fromCompensationBlock(compensationBlock: AttendanceSidepanelCompensationBlockFragment) {
    return new UniqueTimeBlockData(
      (compensationBlock.equivalentMinutesInCents || ONE_HOUR_IN_CENTS) / 100,
      compensationBlock.minutes,
      compensationBlock.categoryName,
      (compensationBlock.rawMinutesInCents || ONE_HOUR_IN_CENTS) / 100,
      compensationBlock.compensationPool,
      Number(compensationBlock.categoryId)
    )
  }

  constructor(
    equivalentMinutes: number,
    minutes: number,
    name: string,
    rawMinutes: number,
    sourcePoolType: AttendanceEnumsPoolTypeEnum,
    timeSettingsCustomTimeRangeCategoryId: Maybe<number> | undefined
  ) {
    this.equivalentMinutes = equivalentMinutes
    this.minutes = minutes
    this.name = name
    this.rawMinutes = rawMinutes
    this.sourcePoolType = sourcePoolType
    this.timeSettingsCustomTimeRangeCategoryId = timeSettingsCustomTimeRangeCategoryId
  }

  get multiplier() {
    return this.equivalentMinutes / this.rawMinutes
  }

  get isDiscardedSource() {
    return this.sourcePoolType == 'discarded'
  }
}
